import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

const SIZES = [
  { v: 'sm', label: 'صغير' },
  { v: 'md', label: 'متوسط' },
  { v: 'lg', label: 'كبير' },
  { v: 'xl', label: 'عريض' },
];

export function EditCardDialog({ open, onOpenChange, card, setCard, onSave, catalog, palette }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader><DialogTitle>تعديل البطاقة</DialogTitle></DialogHeader>
        {card && (
          <div className="space-y-4">
            <div>
              <label className="text-sm text-slate-700 mb-1 block">العنوان</label>
              <Input
                value={card.title ?? catalog[card.key]?.title ?? ''}
                onChange={(e) => setCard({ ...card, title: e.target.value })}
                data-testid="card-title-input"
              />
            </div>
            <div>
              <label className="text-sm text-slate-700 mb-1 block">اللون</label>
              <div className="flex flex-wrap gap-2">
                {palette.map(c => (
                  <button
                    key={c.value}
                    type="button"
                    onClick={() => setCard({ ...card, color: c.value })}
                    className={`w-9 h-9 rounded-md ${c.bg} ${card.color === c.value ? 'ring-2 ring-offset-2 ' + c.ring : ''}`}
                    title={c.name}
                  />
                ))}
                <input
                  type="color"
                  value={card.color}
                  onChange={(e) => setCard({ ...card, color: e.target.value })}
                  className="w-9 h-9 rounded-md cursor-pointer"
                />
              </div>
            </div>
            <div>
              <label className="text-sm text-slate-700 mb-1 block">الحجم</label>
              <div className="grid grid-cols-4 gap-2">
                {SIZES.map(s => (
                  <button
                    key={s.v}
                    type="button"
                    onClick={() => setCard({ ...card, size: s.v })}
                    className={`p-2 border rounded-md text-sm ${card.size === s.v ? 'border-[#B4935A] bg-[#B4935A]/10 text-slate-900' : 'border-slate-200'}`}
                  >
                    {s.label}
                  </button>
                ))}
              </div>
            </div>
            <Button onClick={() => onSave(card)} className="w-full bg-slate-900 text-white" data-testid="save-card-edit">حفظ</Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}

export function AddCardDialog({ open, onOpenChange, availableKeys, catalog, onAdd }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader><DialogTitle>إضافة بطاقة</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-2 max-h-[60vh] overflow-y-auto">
          {availableKeys.map(k => {
            const cat = catalog[k];
            const Icon = cat.icon;
            return (
              <button
                key={k}
                onClick={() => onAdd(k)}
                className="border border-slate-200 rounded-md p-3 hover:border-[#B4935A] flex items-center gap-3 text-start transition-colors"
              >
                <div className="w-9 h-9 rounded-md flex items-center justify-center" style={{ backgroundColor: cat.color + '15' }}>
                  <Icon size={18} style={{ color: cat.color }} />
                </div>
                <div>
                  <div className="text-sm font-medium">{cat.title}</div>
                  <div className="text-xs text-slate-500">{cat.kind === 'chart' ? 'رسم بياني' : 'بطاقة KPI'}</div>
                </div>
              </button>
            );
          })}
          {availableKeys.length === 0 && <div className="col-span-2 text-center text-slate-500 py-6">جميع البطاقات مضافة</div>}
        </div>
      </DialogContent>
    </Dialog>
  );
}
